import { Navigate } from 'react-router';
import { AppSplash } from '@fms/ui';
import { useSession } from '../session';

/** Landing decision for `/` (and unknown paths). Waits for the silent restore
 *  so we never bounce a returning citizen, then sends them to the catalogue if
 *  signed in or straight to the login screen if not — routing through the
 *  protected /services first would briefly park an anonymous visitor on a URL
 *  they have no access to.
 *
 *  Registered outside the layout route (see router.tsx), so what shows during
 *  the wait is a bare splash and not the signed-out app chrome. */
export function RootRedirect() {
  const { user, ready } = useSession();
  if (!ready) return <AppSplash />;
  // An account midway through the signup questions goes to the same place as an
  // anonymous one: the login route, which renders the profile step for it.
  if (!user || !user.profileComplete) return <Navigate to="/auth/login?next=%2Fservices" replace />;
  return <Navigate to="/services" replace />;
}
